import { messages as messagesPtBr } from './pt-BR';
import { messages as messagesEnUs } from './en-US';

export const resources = {
  ...messagesPtBr,
  ...messagesEnUs,
};
